/** Endpoints #1-#3 — login, logout, boot gate (§5.1, §10.1). */

import type { AuthMeResponse, LoginBody } from '@lw/shared';
import { apiJson, apiVoid } from './client';

/**
 * #3 `GET /api/auth/me`. A `401` is a legitimate answer here (the SPA boot gate), so this call
 * opts out of the global redirect — the auth gate turns it into a `/login` navigation itself.
 */
export function getAuthMe(signal?: AbortSignal): Promise<AuthMeResponse> {
  return apiJson<AuthMeResponse>('/auth/me', { signal, skipAuthRedirect: true });
}

/**
 * #1 `POST /api/auth/login` — `204` + `Set-Cookie` on success, `401` on a wrong password,
 * `429` + `Retry-After` while locked out (§10.2). The login screen renders both inline.
 */
export function login(body: LoginBody): Promise<void> {
  return apiVoid('/auth/login', { method: 'POST', body, skipAuthRedirect: true });
}

/** #2 `POST /api/auth/logout` */
export function logout(): Promise<void> {
  return apiVoid('/auth/logout', { method: 'POST' });
}
